import { render, staticRenderFns } from "./AuthenticationReset.vue?vue&type=template&id=4b514621&"
import script from "./AuthenticationReset.vue?vue&type=script&lang=js&"
export * from "./AuthenticationReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports